import { render, staticRenderFns } from "./TransferTokenQueue.vue?vue&type=template&id=1740df6e&scoped=true"
import script from "./TransferTokenQueue.vue?vue&type=script&lang=js"
export * from "./TransferTokenQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1740df6e",
  null
  
)

export default component.exports